<template>
  <div class="d-flex align-items-center">
    <label :for="id" class="pr-3">{{ $t("global.list-size") }}</label>
    <div>
      <select :id="id" :value="size" v-on:change="setSize" class="form-control">
        <option v-for="option in sizeOptions" v-bind:key="option" v-bind:value="option">
          {{ option }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import { uniqueId } from "lodash-es";

export default {
  name: "TableSize",
  props: {
    name: String,
    pagination: Object,
    sizeOptions: {
      type: Array,
      default: function () {
        return [5, 10, 25, 50, 100];
      },
    },
  },
  setup(props, { emit }) {
    const id = uniqueId(
      props.name ? `${props.name?.toLowerCase()}-list-size-input-` : "list-size-input-"
    );
    const size = computed(() => {
      let i = 0;
      while (i < props.sizeOptions.length - 1 && props.pagination.size > props.sizeOptions[i]) {
        i++;
      }
      return props.sizeOptions[i];
    });
    const setSize = (event) => {
      emit("update:pagination", { index: null, size: Number(event.target.value) });
    };

    return {
      id,
      setSize,
      size,
    };
  },
};
</script>

<style lang="scss" scoped>
label {
  display: inherit;
  margin-bottom: 0;
}
</style>
